import { SelectedDocumentType } from "./enums";
import { SelectedFilters } from "./interfaces";

export const initialSelectedFilters: SelectedFilters = {
    selectedDocumentType: SelectedDocumentType.All,
    selectedKapps: [],
    selectedTags: [],
};